import { render, staticRenderFns } from "./HeaderSubMenuItem.vue?vue&type=template&id=b379269c"
import script from "./HeaderSubMenuItem.vue?vue&type=script&lang=js"
export * from "./HeaderSubMenuItem.vue?vue&type=script&lang=js"
import style0 from "./HeaderSubMenuItem.vue?vue&type=style&index=0&id=b379269c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports